<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="用户姓名">
                <!--<el-input v-model="formInline.userId" placeholder="用户ID"></el-input>-->
                <el-select v-model="formInline.userId"
                           filterable
                           remote
                           clearable
                           reserve-keyword
                           placeholder="请输入用户姓名"
                           :remote-method="getUserList"
                           :loading="loading"
                >
                    <el-option
                            v-for="item in userList"
                            :key="item.userId"
                            :label="item.userNick"
                            :value="item.userId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
                <el-button type="success" @click="handleAdd">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize"  v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="createName" label="优惠券创建人"></el-table-column>
             <el-table-column prop="maxValue" label="最大金额"></el-table-column>
            <el-table-column prop="maxNum" label="最大数量"></el-table-column>
            <el-table-column label="操作" fixed="right" width="80">
                <template slot-scope="scope">
                    <el-button type="warning " size="mini" @click="handleUpdate(scope.row)">修改</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="用户管理" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="用户姓名" :required="true">
                    <!--<el-input v-model="form.userId" placeholder="手动复制吧 " clearable></el-input>-->
                    <el-select v-model="form.userId"
                               filterable
                               remote
                               clearable
                               reserve-keyword
                               placeholder="请输入用户姓名"
                               :remote-method="getUserList"
                               :loading="loading"
                    >
                        <el-option
                                v-for="item in userList"
                                :key="item.userId"
                                :label="item.userNick"
                                :value="item.userId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="最大金额">
                    <el-input-number v-model="form.maxValue" :min="0"   label="最大金额"></el-input-number>
                </el-form-item>
                <el-form-item label="最多数量">
                    <el-input-number v-model="form.maxNum" :min="0"  label="最多数量"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateOrAdd">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        getMallUserList,
        getCashticketUserInfoList,
        updateOrAddCashtickeUserInfo
    } from '../../api/api'


    //定义组件
    export default {
        data() {
            return {
                dataList: [],
                loading: true,
                dialogFormVisible: false,
                formInline: {
                    userId:'',
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                userList:[],
                form: {
                    userId: '',
                    maxValue:100,
                    maxNum: 10000,
                    id: '',
                }
            }
        },
        //挂载时候执行
        mounted() {
            this.getList();
        },
        methods: {
            //定义查询方法
            getList() {
                this.loading = true;
                getCashticketUserInfoList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.formInline.recordsTotal = res.data.value.total;
                        this.dataList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            getUserList(queryString) {
                this.loading = true;
                getMallUserList({
                    userName: "",
                    userNick: queryString,
                    currentPage: 1,
                    pageSize: 15
                }).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.userList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleAdd() {
                this.form.id=''
                this.dialogFormVisible = true;
            },
            handleUpdate(row) {
                this.form= {
                    userId: row.userId,
                    maxValue: row.maxValue,
                    maxNum: row.maxNum,
                    id: row.id,
                }
                this.dialogFormVisible = true;
                this.getUserList(row.createName);
            },
            updateOrAdd() {
                const loading = this.$loading(this.GCONFIG.loadingParam);
                updateOrAddCashtickeUserInfo(this.form).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/cash/cashcreaterule.vue